import { useCallback, FunctionComponent } from 'react';

// Utilities
import classnames from 'classnames';

// Components
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Styles
import styles from './Question.module.scss';
import FormQuestion from '@Pages/hoi-dap/Components/Asking/FormQuestion';

interface QuestionProps {
    className?: string;
    onBack?: () => void;
}

const Question: FunctionComponent<QuestionProps> = ({ className, onBack }) => {
    const { deviceType } = useViewDetected();

    const goBack = useCallback(() => onBack(), []);

    const wrapperClassName = classnames([styles.wrapper, styles[deviceType], className]);

    return (
        <div className={wrapperClassName}>
            <div className={styles.head}>
                <span className={styles.back} onClick={goBack} />
            </div>
            <FormQuestion className={styles.form_wrapper} formClassName={styles.form} />
        </div>
    );
};

Question.defaultProps = {
    onBack: () => null,
};

export default Question;
